(ns ui.view.counterparty-diligence.responder-form.util
  (:require
   [clojure.string :as string]
   [common.schema.entities.counterparty-diligence.templates.util :as tu]
   [ui.util :as uu]))

(defn display-string
  [{:keys [value data-type editor-type options entities date-format lang-kw]
    :or {lang-kw :en}}]
  (case data-type
    :data.type/text-simple (str value)
    :data.type/text-multiline (str value)
    :data.type/vector (if (= editor-type :editor.type/nationality-list)
                        (tu/nationality-rows->display value lang-kw)
                        (str value))
    :data.type/file (if (seq value)
                      (->> value
                           (mapv #(get entities %))
                           (mapv :attachment/filename)
                           (string/join "; "))
                      "")
    :data.type/keyword (if value
                         (let [opt (->> options
                                        (filterv #(= (:value %) value))
                                        first)
                               label (cond
                                       (string? (:label opt))
                                       (:label opt)

                                       (map? (:label opt))
                                       (get-in opt [:label lang-kw])

                                       (map? (:translations opt))
                                       (get-in opt [:translations lang-kw])

                                       :else "")]
                           label)
                         "")
    :data.type/date (uu/format-date value date-format)
    (str value)))
